import React from 'react'

import { User } from "./types"

interface AvatarProps {
  user: User,
  className?: string,
  size?: "large" | "small" | "extraSmall" | "default"
}

const sizes = {
  large: 60,
  small: 40,
  extraSmall: 32,
  default: 48
}

export default function Avatar({ user, className, size = "default" }: AvatarProps) {
  const sizeValue = sizes[size]

  let fullClassName = 'avatar '

  if(className) {
    fullClassName += ` ${className}`
  }

  if (size == "small" || size === "extraSmall" || size == "large") {
    fullClassName += ` ${size}`
  }

  if(user && user.customPhotoPath) {
    const backgroundColor = "FFFFFF"
    const src = `https://spark-golf-user-photos.imgix.net/${user.customPhotoPath}?w=${sizeValue}&h=${sizeValue}&fit=facearea&faceindex=1&facepad=2&mask=ellipse&mask-bg=${backgroundColor}`
    return (
      <div className={fullClassName} style={{backgroundColor: 'transparent'}}>
        <img src={src} width={sizeValue} height={sizeValue} alt={user.initials} />
      </div>
    )
  } else {
    return (
      <div className={fullClassName}>
        {user.initials}
      </div>
    )
  }
}
